import { Add } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import React from "react";

import SortedDataGridPro6 from "../../../../../../../../design/sorted-datagrid-pro-6";
import useGatAdminConfigData from "../../../../../../controllers/use-gat-admin-config-data";
import useGatAttendanceColumns from "../../controllers/use-gat-attendance-columns";

const AttendanceManagementTable = ({ handleOpenEdit, handleOpenAdd }: any) => {
	const { columns } = useGatAttendanceColumns(handleOpenEdit);
	const { getLeaveTypesData, getLeaveTypesStatus } = useGatAdminConfigData();

	return (
		<Box
			sx={{
				border: "1px solid var(--divider, rgba(0, 0, 0, 0.12))",
				borderRadius: "8px",
				backgroundColor: "#fff",
				padding: "20px",
				marginTop: "16px",
			}}
		>
			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					alignItems: "center",
					justifyContent: "space-between",
					paddingTop: "20px",
					paddingBottom: "20px",
				}}
			>
				<Typography
					sx={{
						fontFamily: "Roboto",
						fontWeight: 400,
						fontSize: "16px",
						lineHeight: "24px",
						color: "#000000DE",
					}}
				>
					Time Off Types
				</Typography>
				<Button
					disableElevation
					sx={{ height: 36 }}
					variant='outlined'
					color='primary'
					onClick={handleOpenAdd}
					startIcon={<Add />}
				>
					Time Off Type
				</Button>
			</Box>
			<Box
				sx={{
					padding: "12px 8px",
				}}
			>
				<SortedDataGridPro6
					columns={columns}
					rows={getLeaveTypesData}
					defaultSortField="timeOffType"
					//disableRowSelectionOnClick
					disableColumnSelector
					disableDensitySelector
					disableColumnMenu
					//disableColumnPinning
					//disableColumnReorder
					//disableColumnResize
					pagination
					initialState={{
						...getLeaveTypesData,
						pagination: { paginationModel: { pageSize: 10 } },
						filter: {},
					}}
					pageSizeOptions={[10, 25, 50]}
					autoHeight
					getRowHeight={() => "auto"}
					loading={getLeaveTypesStatus === "pending"}
					sx={{
						border: "none !important",
						".MuiDataGrid-cell": {
							"&:focus": {
								outline: "none",
							},
							"&.hover-column-cell": {
								position: "sticky",
								right: 24,
								zIndex: 1,
							},
							"& .hover-content": {
								transition: "opacity 0.3s ease-in-out",
								opacity: 0,
								backgroundColor: "transparent",
							},
						},
						".MuiDataGrid-cell:focus-within": {
							outline: "none",
						},
						"& .MuiDataGrid-columnHeader:focus-within": {
							outline: "none",
						},
						".MuiDataGrid-row:hover .hover-column-cell .hover-content": {
							opacity: 1,
							backgroundColor: "transparent",
						},
					}}
				/>
			</Box>
		</Box>
	);
};

export default AttendanceManagementTable;
